import { createContext } from 'react';
import type { FindStoreResult } from 'autogen/swagger/all';
import type { SearchRequestBody } from 'components/QuickViewSearch/shared/types';

export const OnSearchCallbackContext = createContext<((data: SearchRequestBody) => void) | undefined>(undefined);
export const OnGeoLocationCallbackContext = createContext<((latitude: number, longitude: number) => void) | undefined>(
    undefined
);
export const OnSelectParcelPickupContext = createContext<(() => void) | undefined>(undefined);
export const FindStoreResultContext = createContext<FindStoreResult | undefined>(undefined);
